<div class="shell" [class.shell--landing-route]="isLandingRoute()">

@if (!isBlockingTermsScreen()) {
  <app-toolbar></app-toolbar>
}
  <!-- Page Host -->
  <main
    class="page-host"
    [class.page-host--with-bottom-nav]="showBottomNav()"
    [class.page-host--no-toolbar]="isBlockingTermsScreen()"
    [class.page-host--landing-route]="isLandingRoute()"
    role="main"
  >
    <router-outlet></router-outlet>
  </main>

@if (!isBlockingTermsScreen()) {
  <app-footer [withBottomNav]="showBottomNav()"></app-footer>
}

  <!-- Bottom Navigation (Mobile & Tablet Only, Hidden on Desktop 1024px+) -->
  @if (showBottomNav()) {
    <app-bottom-nav></app-bottom-nav>
  }

  @if (showHealthNavWidget()) {
    <app-health-nav-widget
      [withBottomNav]="showBottomNav()"
      [avoidMobileActionFab]="isPostDetailRoute()"
    ></app-health-nav-widget>
  }

</div>

<!-- Add CSS class to hide mobile elements on desktop -->
<style>
  @media (min-width: 1024px) {
    .hide-on-desktop {
      display: none !important;
    }
  }

  .topbar-nav {
    display: none;
  }

  @media (min-width: 1024px) {
    .topbar-nav {
      display: flex;
    }
  }
</style>
